<div>Количество дней, который элемент будет в корзине до полного удаления: {{dayInBasket}} д.</div>
<div><a href="/cabinet/dam/basket/log">Лог полного удаления</a></div>
